/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
import {
    Menu,
    Spacer, useDisclosure,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useExperiment, useLogout, useSession } from '@acp/feature/auth';
import { Hide, Show } from '@acp/core-ui';
import { DocumentUploadManager } from '../../../features/document';
import { NotificationButton } from '../../../features/notifications';
import { NavigationMenuItem } from './navigation-menu-item';
import { DiLogo } from '../../di-logo';
import { DesktopNavigationRender, CollapseDesktopMenu } from '../menu-render';
import { NavBarContainer } from '../nav-bar-container';
import { SwitchPortfolioPanel } from '../switch-portfolio-panel';
import { ResponsiveNavigationMenu } from './responsive-navigation-menu';
import { AppNavigationItem } from '../types';

export function DesktopNavigation({ navItems }: { navItems: AppNavigationItem[] }) {
    const switchPortfolioDisclosure = useDisclosure();
    const { handleLogout } = useLogout();
    const experiments = useExperiment();
    const {
        complianceSystemUrl,
        complianceUserName,
        isImpersonating,
    } = useSession();

    return (
        <NavBarContainer>
            <Link to="/">
                <Show above="lg">
                    <DiLogo variant="horizontalRGB" h="2em" mb="6px" userSelect="none" />
                </Show>
                <Hide above="lg">
                    <DiLogo variant="markOrange" h="2em" mb="6px" userSelect="none" />
                </Hide>
            </Link>

            {/* render desktop navigation items */}
            <Menu>
                <Show above="xl">
                    {navItems.map((navItem, index) => (
                        <DesktopNavigationRender key={index} menuItem={navItem} />
                    ))}
                </Show>
                <Hide above="xl">
                    {navItems.filter((x) => !x.collapse).map((navItem, index) => (
                        <DesktopNavigationRender key={index} menuItem={navItem} />
                    ))}
                    <CollapseDesktopMenu items={navItems} />
                </Hide>
            </Menu>

            <Spacer />

            <DocumentUploadManager />

            <NotificationButton />

            {/* user menu */}
            <ResponsiveNavigationMenu
                label={complianceUserName}
            >
                <NavigationMenuItem
                    onClick={switchPortfolioDisclosure.onOpen}
                    label="Switch Portfolio"
                />
                {
                    experiments?.userExperiments?.AgencyCompliancePortalAdvancedAnalytics === true
                    && (
                        <NavigationMenuItem
                            to="/analytics"
                            label="Analytics"
                        />
                    )
                }
                {isImpersonating && (
                    <NavigationMenuItem
                        label="Switch Back"
                        onClick={() => handleLogout(`${complianceSystemUrl}/App/switchBackToOriginalUser`)}
                    />
                )}
                <NavigationMenuItem
                    to="/settings"
                    label="Settings"
                />
                <NavigationMenuItem label="Logout" onClick={() => handleLogout()} />
            </ResponsiveNavigationMenu>

            {/* desktop switch portfolio */}
            <SwitchPortfolioPanel.Desktop
                isOpen={switchPortfolioDisclosure.isOpen}
                onClose={switchPortfolioDisclosure.onClose}
            />
        </NavBarContainer>
    );
}
